export function CheckboxOutlineIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="1.94608" y="1.94608" width="16.1078" height="16.1078" rx="2.49833" fill="white" stroke="#D0D5DD" stroke-width="1.67" />
    </svg>
  );
}

CheckboxOutlineIcon.displayName = 'CheckboxOutlineIcon';
